import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    :root{
        --primary: #15181C;
        --secondary: #F7F9FC;
        --gray: #D9D9D9;
        --blue: #4766FF;
        --white: #FFFFFF;
        --gold: #C2A35D;
        --gold-light: #E2C88F;
        --shade: #EFEFEF
        --primary-light: #424242;
    }

    body{
        background-color: var(--primary);
        color: var(--secondary);
        font-family: "Dosis", sans-serif;
        font-size: 1.2rem;
        font-weight: 400;
    }

    ul, nav{list-style-type: none;}

    a{text-decoration: none;}

    
`

export const SwiperCustomStyles = createGlobalStyle`
  .swiper-button-next,
  .swiper-button-prev {
    color: var(--gold);
  }

  .swiper-pagination-bullet {
    background-color: var(--gold);
    opacity: 0.5;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
  }
`;
    
